{
  "version": 1,
  "asset_id": "8e46870b-05c9-4d22-b8df-2e96ea6fa369",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/8e46870b-05c9-4d22-b8df-2e96ea6fa369/svc-aeo-geo-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/8e46870b-05c9-4d22-b8df-2e96ea6fa369/svc-aeo-geo-640.avif",
  "original_filename": "svc-aeo-geo-640.avif",
  "size": 3061,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:38Z"
}
